import { useEffect, useState } from "react"
import { useSelector } from "react-redux"

import MedpayItem from "./MedpayItem"

import classes from '../Shared/Container.module.css'

const MedpayDetails = ({branch}) => {
    const activeCase = useSelector(state => state.case.activeCase)   

    const [data, setData] = useState(null)

    useEffect(() => {
        if (activeCase) {
            let arr = [...activeCase.mp_pip_um].sort(function(x, y) {
                return ((x.active == y.active) ? 0 : x.active ? -1 : 1);
            });

            let arr2 

            if (branch == 'medpay') {
                arr2 = arr.sort(function(x, y) {
                    return ((x.is_primary_insurance == y.is_primary_insurance) ? 0 : x.is_primary_insurance ? -1 : 1)
                });
            } else if (branch == 'um') {
                arr2 = arr.sort(function(x, y) {
                    return ((x.is_um_primary_insurance == y.is_um_primary_insurance) ? 0 : x.is_um_primary_insurance ? -1 : 1)
                });
            }
      
            setData(arr2)
        }
    }, [activeCase])


    return <div className={classes.container}>
        {data && data.map((item, index) => (
            <MedpayItem key={item.id} data={item} branch={branch} lastChild={index == data.length-1}/>
        ))}
    </div>
}

export default MedpayDetails